'use strict';
/**
 * @author Maxim Seredkin
 */
export default function () {
    return {
        restrict: 'A',
        controller: [function () {

        }],
        link: function ($scope, element, attrs) {
            if (attrs.phase) {
                element.html(' ');
                element.css("width", attrs.phase + '%')
            }
        }
    };
}